"use strict";

import LazyLoad from "vanilla-lazyload";
import smartquotes from "smartquotes";

import attachBurgerListener from "./attachBurgerListener";
import attachContentNavListener from './attachContentNavListener';
// import fitvids from "./fitvids";

const imageLazyLoad = () => {
  if (!document.lazyLoadInstance) {
    document.lazyLoadInstance = new LazyLoad({elements_selector: '.lazyload'});
  }

  document.lazyLoadInstance.update();
}

const fireAllMicroScripts = () => {
  const microScriptFns = [attachBurgerListener, attachContentNavListener, imageLazyLoad, smartquotes];

  for (const fn of microScriptFns) {
    try {
      fn();
    } catch (err) {
      console.log(err);
    }
  }
};

export default fireAllMicroScripts;
